module.exports = __webpack_public_path__ + "img/main_culture5.dddd84ee.png";